import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { MdbSelectComponent } from 'mdb-angular-ui-kit/select';

@Directive({
  selector: 'mdb-select',
})
export class MdbSelectAccessibilityDirective implements AfterViewInit {
  constructor(private elementRef: ElementRef<HTMLElement>, private select: MdbSelectComponent) {}

  ngAfterViewInit(): void {
    const selectElement = this.elementRef.nativeElement;
    selectElement.removeAttribute('aria-role');
    selectElement.removeAttribute('aria-multiselectable');
    selectElement.setAttribute('role', 'combobox');

    const input = selectElement.querySelector<HTMLInputElement>('input.select-input');
    const labelId = this.select.ariaLabelledby || this.getAssociatedLabelId();

    if (input && labelId) {
      input.setAttribute('aria-labelledby', labelId);
      selectElement.setAttribute('aria-labelledby', labelId);
    } else if (input && this.select.ariaLabel) {
      input.setAttribute('aria-label', this.select.ariaLabel);
      selectElement.setAttribute('aria-label', this.select.ariaLabel);
    }
  }

  private getAssociatedLabelId(): string {
    const selectId = this.elementRef.nativeElement.id;
    const label = this.elementRef.nativeElement.parentElement?.querySelector<HTMLLabelElement>(
      `label[for="${selectId}"]`
    );

    if (!label) {
      return '';
    }

    if (!label.id) {
      label.id = `${selectId}-label`;
    }

    return label.id;
  }
}
